import {
  Grid,
  Calculator,
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  LineChart,
  Users,
} from "lucide-react";

import { featureFlags } from "@/config";

// Exported so PricingAudit.tsx's badge-matching logic (gpcPendingCount /
// gprtAnsweredCount) reads the same literal instead of its own copy that
// could silently drift out of sync with these hrefs.
export const GPC_PATH = "/group-pricing-calculator";
export const GPRT_PATH = "/group-pricing-requests";

const toolsSection = [
  {
    href: "/pricing-audit-tool/instances",
    icon: Grid,
    title: "Pricing & Audit",
  },
  {
    href: GPC_PATH,
    icon: Calculator,
    title: "Group Pricing",
  },
  ...(featureFlags.groupPricingRequests
    ? [
        {
          href: GPRT_PATH,
          icon: ClipboardList,
          title: "Request Quote",
        },
      ]
    : []),
  {
    href: "/active-leads",
    icon: Users,
    title: "Active Leads",
    visibleToExternal: true,
    requires: "sales" as const,
  },
  {
    href: "/events",
    icon: CalendarDays,
    title: "Events",
  },
  {
    href: "/ota-audits",
    icon: ClipboardCheck,
    title: "OTA Audits",
  },
  {
    href: "/performance-analysis",
    icon: LineChart,
    title: "Performance",
    visibleToExternal: true,
    requires: "revenue" as const,
  },
];

const navItems = [
  {
    title: "Tools",
    pages: toolsSection,
  },
];

export default navItems;
